import React from 'react';
import { Screen } from '../App/Screen';

export function NotFound() {
    return (
        <Screen title="Not Found">
            <p>The page you requested was not found</p>
        </Screen>
    );
}